import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-white/10 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="font-display font-black text-2xl tracking-tight mb-3">VerifiedGamblers</div>
          <p className="text-sm text-[#8B97AE] max-w-md leading-relaxed">
            {t("footer.tagline")}
          </p>
        </div>
        <div className="md:col-span-4 md:col-start-8 grid grid-cols-2 gap-6 text-sm">
          <Link to="/how-it-works" data-testid="footer-how-it-works" className="text-white hover:text-[#2DD4A7] transition-colors">{t("footer.howItWorks")}</Link>
          <Link to="/faq" data-testid="footer-faq" className="text-white hover:text-[#2DD4A7] transition-colors">{t("footer.faq")}</Link>
          <Link to="/legal/imprint" data-testid="footer-imprint" className="text-white hover:text-[#2DD4A7] transition-colors">{t("footer.imprint")}</Link>
          <Link to="/legal/privacy" data-testid="footer-privacy" className="text-white hover:text-[#2DD4A7] transition-colors">{t("footer.privacy")}</Link>
          <Link to="/legal/terms" data-testid="footer-terms" className="text-white hover:text-[#2DD4A7] transition-colors">{t("footer.terms")}</Link>
          <Link to="/legal/responsible" data-testid="footer-responsible" className="text-white hover:text-[#2DD4A7] transition-colors">{t("footer.responsible")}</Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between text-xs font-mono text-[#8B97AE]">
          <span>{t("footer.copy")}</span>
          <span data-testid="footer-age-note">18/21+ · BeGambleAware</span>
        </div>
      </div>
    </footer>
  );
}
